import { ArrowLeftIcon } from "lucide-react";
import { Badge } from "~/components/ui/badge";
import { Text } from "~/components/text";
import { PickerProject } from "./add-to-project-picker.types";
import { LetterGroup } from "./use-picker-state";
import { ProjectRow } from "./project-row";

interface ProjectDrilldownListProps {
  title: string;
  backLabel: string;
  count: number;
  groups: LetterGroup[];
  selectionDisabled?: boolean;
  assignedSelectionEnabled?: boolean;
  onBack: () => void;
  onSelect: (project: PickerProject) => void;
}

export const ProjectDrilldownList = ({
  title,
  backLabel,
  count,
  groups,
  selectionDisabled,
  assignedSelectionEnabled,
  onBack,
  onSelect,
}: ProjectDrilldownListProps) => (
  <div className="flex flex-col">
    <div className="flex items-center gap-2 px-2 py-2">
      <button
        type="button"
        onClick={onBack}
        aria-label={backLabel}
        className="rounded-sm p-1 hover:bg-accent"
      >
        <ArrowLeftIcon className="h-4 w-4" />
      </button>
      <Text as="span" variant="label">
        {title}
      </Text>
      <Badge variant="secondary" className="ml-auto font-normal">
        {count}
      </Badge>
    </div>
    {groups.map((group) => (
      <div key={group.letter}>
        <div className="sticky top-0 z-10 bg-background px-2 py-1">
          <Text as="span" variant="metricCaption">
            {group.letter}
          </Text>
        </div>
        {group.projects.map((project) => (
          <ProjectRow
            key={project.id}
            project={project}
            selectionDisabled={selectionDisabled}
            assignedSelectionEnabled={assignedSelectionEnabled}
            onSelect={onSelect}
          />
        ))}
      </div>
    ))}
  </div>
);
